
    import __i18nConfig from '@next-translate-root/i18n'
    import __loadNamespaces from 'next-translate/loadNamespaces'
    import * as React from 'react';
import { GetStaticPaths, NextPage } from 'next';
import { useUser } from 'components/hooks/state';
import PathContentEnrolled from 'pages/path/content/enrolled';
import PathContent from 'pages/path/content';
import ItemHeroEnrolled from 'components/atomic/organisms/item-hero/enrolled';
import ItemHero from 'components/atomic/organisms/item-hero';
import MainLayout from 'components/layouts/main-layout';
import SEO from 'pages/path/seo';
import { setCurrentPathId } from 'utils/path';
import devvSdk from 'utils/devv-sdk';
import { Path } from 'types/types';
interface PathDetailsPageProps {
    path: Path;
}
const PathDetails: NextPage<PathDetailsPageProps> = ({ path }) => {
    const { user } = useUser();
    const enrolled = React.useMemo(() => {
        return user?.enrolled_paths.includes(path._id);
    }, [user, path._id]);
    React.useEffect(() => {
        setCurrentPathId(path._id);
    }, [path._id]);
    return (<>
            <SEO path={path}/>
            <MainLayout isFluid>
                {enrolled ? (<>
                        <ItemHeroEnrolled item={path} itemType={path.goal}/>
                        <PathContentEnrolled pathId={path._id}/>
                    </>) : (<>
                        <ItemHero item={path} itemType={path.goal}/>
                        <PathContent path={path}/>
                    </>)}
            </MainLayout>
        </>);
};
export const getStaticPaths: GetStaticPaths = async () => {
    const { data: paths } = await devvSdk.getPathsOverview();
    return {
        paths: paths.map((path) => ({
            params: { slug: path.slug },
        })),
        fallback: false,
    };
};
const getStaticProps = async ({ params }: {
    params: {
        slug: string;
    };
}) => {
    const { data: path } = await devvSdk.getPathBySlug(params.slug);
    return {
        props: {
            path,
        },
    };
};
export default PathDetails;

    async function __Next_Translate__getStaticProps__18916ceb315__(ctx) {
      const res = await getStaticProps(ctx)
      return {
        
        ...res,
        props: {
          ...(res.props || {}),
          ...(await __loadNamespaces({
            ...ctx,
            ...__i18nConfig,
            pathname: '/paths/[slug]/index',
            loaderName: 'getStaticProps',
            loadLocaleFrom: (l, n) => import(`@next-translate-root/locales/${l}/${n}`).then(m => m.default),
          }))
        }
      }
    }
    export { __Next_Translate__getStaticProps__18916ceb315__ as getStaticProps }
  